import styled from 'styled-components';
import RadioFieldSet from 'components/ui/RadioFieldSet';

import { colours } from 'themes/default';

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const StyledRadioFieldSet = styled(RadioFieldSet)`
  color: ${colours.Shades.BlueShade40};
`;

export const StyledWarningMessage = styled.div`
  color: red;
`;
